class AboutHogMotion {
  constructor(root) {
    this.root = root;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.reduceMotion) return;

    root.classList.add('about-hog--motion');
    this.revealItems = root.querySelectorAll([
      '.about-hog__story-grid',
      '.about-hog__problem > *',
      '.about-hog__direction article',
      '.about-hog__section-head',
      '.about-hog__together-intro',
      '.about-hog__service-grid a',
      '.about-hog__beliefs-title',
      '.about-hog__belief-list article',
      '.about-hog__community > *',
      '.about-hog__trust-grid > *',
      '.about-hog__faq > *',
      '.about-hog__closing .page-width'
    ].join(','));

    this.revealItems.forEach((item, index) => {
      item.classList.add('about-hog__reveal');
      item.style.setProperty('--reveal-delay', `${Math.min(index % 4, 3) * 70}ms`);
    });

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        this.observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });

    this.revealItems.forEach((item) => this.observer.observe(item));
  }
}

document.querySelectorAll('.about-hog').forEach((root) => new AboutHogMotion(root));

